import type { ClinicalIconProps } from "./shared";
import { ClinicalIconSvg, FillPath, StrokePath } from "./shared";

export function IconFixedRestorationCategory(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M6.5 9C6.5 5.8 8.2 4.3 9.6 5C10.4 5.4 11 6.2 12 6.2C13 6.2 13.6 5.4 14.4 5C15.8 4.3 17.5 5.8 17.5 9C17.5 13 16.4 19.5 12 19.5C7.6 19.5 6.5 13 6.5 9Z" />
      <StrokePath d="M12 6.4v2" />
    </ClinicalIconSvg>
  );
}

export function IconImplantCategory(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M6.8 9C6.8 6 8.4 4.6 9.7 5.3C10.5 5.7 11 6.4 12 6.4C13 6.4 13.5 5.7 14.3 5.3C15.6 4.6 17.2 6 17.2 9C17.2 10.6 17 11.4 16.8 12H7.2C7 11.4 6.8 10.6 6.8 9Z" />
      <StrokePath d="M10.3 12h3.4l-.7 2h-2z" />
      <FillPath d="M11 14h2l-.6 5.2C12 20.4 12 20.4 11.6 19.2Z" />
      <StrokePath d="M10.5 15.4h3M10.7 17h2.6" />
    </ClinicalIconSvg>
  );
}

export function IconRemovableCategory(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M4 12.5C4 17.5 7.8 19.5 12 19.5C16.2 19.5 20 17.5 20 12.5V11.5H4Z" />
      <StrokePath d="M4.5 11.5C5.3 7.8 6.6 7.8 7 11.5C7.5 7.4 9 7.4 9.4 11.5C9.9 7.2 11.4 7.2 11.9 11.5C12.4 7.2 13.9 7.2 14.3 11.5C14.8 7.4 16.3 7.4 16.7 11.5C17.1 7.8 18.4 7.8 19.2 11.5" />
    </ClinicalIconSvg>
  );
}

export function IconSplintCategory(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M4 6.5h3.7C7.7 13.5 9.3 16.6 12 16.6C14.7 16.6 16.3 13.5 16.3 6.5H20C20 15.2 17 19.5 12 19.5C7 19.5 4 15.2 4 6.5Z" />
    </ClinicalIconSvg>
  );
}

export function IconDiagnosticCategory(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M8 5.2C8 4 9.2 3.4 10.4 4C11.2 4.4 12.8 4.4 13.6 4C14.8 3.4 16 4 16 5.2V14C16 17.6 14.2 19.4 12 19.4C9.8 19.4 8 17.6 8 14Z" />
      <FillPath d="M9.6 6C10.2 5.4 13.8 5.4 14.4 6V13.8C14.4 16 13.4 17.6 12 17.6C10.6 17.6 9.6 16 9.6 13.8Z" />
      <StrokePath d="M17.5 6.5l3-3M19 5l1.6 1.6" />
    </ClinicalIconSvg>
  );
}

export function IconOrthodonticsCategory(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M4 5.5c0 8.4 3.6 14 8 14s8-5.6 8-14" />
      <StrokePath d="M7.2 8.4h9.6" />
      <StrokePath d="M5.2 11.2h2.6M16.2 11.2h2.6" />
    </ClinicalIconSvg>
  );
}
